module.exports = __webpack_public_path__ + "static/scale-model-of-fargo-north-dakota-f51abcb0c3e5799356e2a02ee8244f13.png";